var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

var ForgotPasswordOne = function (_Component) {
  _inherits(ForgotPasswordOne, _Component);

  function ForgotPasswordOne() {
    _classCallCheck(this, ForgotPasswordOne);

    var _this = _possibleConstructorReturn(this, (ForgotPasswordOne.__proto__ || Object.getPrototypeOf(ForgotPasswordOne)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.state = {
      email: ""
    };
    return _this;
  }

  _createClass(ForgotPasswordOne, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        email: event.target.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.requestPasswordReset(this.state.email).then(function () {
        _this2.setState({
          email: ""
        });

        _this2.changeStep(authDrawerConstants.FORGOTPASSWORD2);
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.container },
        React.createElement(
          "h3",
          null,
          "Reset password"
        ),
        React.createElement(
          "div",
          { className: styles.marginTop20 },
          "Let us know your email address so we can send you a link to reset your password."
        ),
        React.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          React.createElement(
            "div",
            { className: styles.marginTop40 },
            React.createElement("input", { onChange: this.handleChange, name: "email", type: "text", placeholder: "Email", value: this.state.email })
          ),
          React.createElement(
            "div",
            { className: styles.nextButton },
            React.createElement(
              "button",
              { type: "submit", className: classNames(styles.blueButton1, styles.block, styles.centered) },
              "Reset Password"
            )
          )
        ),
        React.createElement(
          "div",
          { className: classNames(styles.marginTop10, styles.textCenter) },
          React.createElement(
            "a",
            { onClick: this.changeStep.bind(this, authDrawerConstants.SIGNIN), href: "#", className: classNames(styles.blackLink, styles.bold) },
            "Cancel"
          )
        )
      );
    }
  }]);

  return ForgotPasswordOne;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordOne);


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordOne.js